<template>
  <v-app>
    <vertical-nav-menu :is-drawer-open.sync="isDrawerOpen"></vertical-nav-menu>

    <v-app-bar
      app
      flat
      absolute
      color="transparent"
    >
      <div class="boxed-container w-full">
        <div class="d-flex align-center mx-6">
          <!-- Left Content -->
          <v-app-bar-nav-icon
            class="d-block d-lg-none me-2"
            @click="isDrawerOpen = !isDrawerOpen"
          ></v-app-bar-nav-icon>

          <v-spacer></v-spacer>
          <lang-switcher></lang-switcher>
          <theme-switcher></theme-switcher>
          <!--
            The school's notification bell used to hang here, counting
            unresolved complaints, drivers awaiting review and students
            needing a bus - none of which is a family's business, and all of
            which came from an endpoint behind the school middleware that
            answered a parent 403 on a timer. Nothing it could show was ever
            going to be non-zero.
          -->

          <app-bar-user-menu
          :admin-name="adminProfileStore.name"
          :admin-avatar="adminProfileStore.avatar"
          :profile-url="null"
          :admin="false"
          ></app-bar-user-menu>
        </div>
      </div>
    </v-app-bar>

    <v-main>
      <div class="app-content-container boxed-container pa-6">
        <slot></slot>
      </div>
    </v-main>

    <!--
      The activation notice lived here too. It is a licence for the whole
      installation, only the super admin can do anything about it, and a
      family has no idea what it means - so telling them the account is not
      activated is alarming them about somebody else's invoice.
    -->
  </v-app>
</template>

<script>
/*
 * The chrome around the family's panel.
 *
 * It was copied from the school's, badges and all: a notification bell polling
 * an endpoint behind the school middleware every minute - which answers a
 * family 403 - to count unresolved complaints and drivers awaiting review, and
 * links to /drivers, /students and /complaints, none of which a parent may
 * open. The only thing in that reply a family had any use for was their own
 * name, and losing the request meant the account menu showed nobody's.
 *
 * So it asks the family's own endpoint instead, once, for the one thing it
 * needs.
 */
import VerticalNavMenu from './components/vertical-nav-menu/ParentVerticalNavMenu.vue'
import ThemeSwitcher from './components/ThemeSwitcher.vue'
import AppBarUserMenu from './components/AppBarUserMenu.vue'
import LangSwitcher from './components/LangSwitcher.vue'
import { adminProfileStore } from "@/utils/helpers"

export default {
  components: {
    VerticalNavMenu,
    LangSwitcher,
    ThemeSwitcher,
    AppBarUserMenu,
  },
  setup() {
    return { adminProfileStore }
  },
  data() {
    return {
      isDrawerOpen: true,
    }
  },
  mounted() {
    this.loadProfile()
  },
  methods: {
    loadProfile() {
      axios
        .get("/parent-portal/children")
        .then(response => {
          const me = response.data.me
          if (!me) return

          adminProfileStore.name = me.name
          adminProfileStore.avatar = me.avatar
          adminProfileStore.id = me.id
        })
        //the chrome is not the place to report a failed request
        .catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.v-app-bar ::v-deep {
  .v-toolbar__content {
    padding: 0;

    .app-bar-search {
      .v-input__slot {
        padding-left: 18px;
      }
    }
  }
}

.boxed-container {
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
}
</style>
